module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[67]432.74d78a0.woff2";